// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"f9880f41","341":"d04918e4","438":"39bbd81a","706":"9e70ca4a","726":"c270721a","787":"168ff8b4"}[chunkId] + ".chunk.js";
};